var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert_Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    width: 24,
    height: 24,
    rx: 6,
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 9V14",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Vector_2",
    cx: 12,
    cy: 17,
    r: 1,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconWarning);
export default __webpack_public_path__ + "static/media/Alert_Icon_Warning.0a168ca8f27ad28c7317e2565469e337.svg";
export { ForwardRef as ReactComponent };